import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";
import get from "lodash/get";
import { orderAvailableProducts } from "../../../lib/productMappings";

const DEFAULT_UNIT = "CM";

export const query = gql`
  query withDefaultInventoryItems(
    $workId: Int!
    $locale: String!
    $previewTypeIds: [String!]
    $country: String
    $currency: String
    $unit: inventory_Unit!
  ) {
    inventory_defaultInventoryItems(
      workId: $workId
      previewTypeIds: $previewTypeIds
      unit: $unit
      country: $country
      currency: $currency
      locale: $locale
    ) {
      id
      productPageUrls {
        url
        fallbackUrl
      }
      productTypeId
      description
      previewSet {
        previews {
          previewTypeId
          url
        }
      }
      price {
        amount
        currency
        discount {
          amount
          percent
        }
      }
      volumeDiscount {
        id
        thresholds {
          percentOff
          quantity
        }
      }
    }
  }
`;

const useAvailableProducts = ({
  workId,
  previewTypeIds,
  userInfo,
  unit,
  ssr,
}) => {
  const country = get(userInfo, "country");
  const currency = get(userInfo, "currency");
  const locale = get(userInfo, "locale");
  const unitValue = unit || DEFAULT_UNIT;

  const {
    data,
    loading: availableProductsLoading,
    error: availableProductsError,
  } = useQuery(query, {
    variables: {
      workId: parseInt(workId, 10),
      previewTypeIds,
      country,
      currency,
      locale,
      unit: unitValue,
    },
    skip: !(workId && locale && currency && country),
    ssr,
  });

  const availableProducts = get(data, "inventory_defaultInventoryItems") || [];

  return {
    availableProducts: orderAvailableProducts(availableProducts),
    availableProductsLoading,
    availableProductsError,
  };
};

export default useAvailableProducts;
